'use client';

import { HttpStatusCode } from '@lib/http/HttpStatusCode';
import { swrFetcher } from '@lib/http/fetch';
import * as Sentry from '@sentry/nextjs';
import { SWRConfig } from 'swr';

export const SWRProvider = ({ children }) => {
  return (
    <SWRConfig
      value={{
        fetcher: swrFetcher,
        revalidateOnFocus: false,
        shouldRetryOnError: false,
        onError: (error) => {
          if (
            error.status !== HttpStatusCode.Forbidden &&
            error.status !== HttpStatusCode.NotFound &&
            error.status !== HttpStatusCode.Unauthorized
          ) {
            Sentry.captureException(error);
          }
        },
      }}
    >
      {children}
    </SWRConfig>
  );
};
